import {defaultSvgProps, SvgProps} from '../type/props'

export const WarningTriangleIcon = (props?: SvgProps) => {
  const {width, height, fill, stroke, style} = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: 'none',
    stroke: 'currentColor',
    style: {
      flexShrink: 0,
    },
  })

  return (
    <svg
      viewBox='0 0 24 24'
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={style}>
      <path d='m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3' />
      <path d='M12 9v4' />
      <path d='M12 17h.01' />
    </svg>
  )
}
